import { useEffect, useState } from "react";
import ProcessoModal from "./ProcessoModal";
import { movimentacaoProcessualService } from "../../api/movimentacaoProcessualService";

const HistoricoProcessual = ({
  aberto,
  processo,
  usuarios,
  onFechar,
  onSalvarProcesso
}) => {
  const [movimentacoes, setMovimentacoes] = useState([]);
  const [paginacao, setPaginacao] = useState({
    total: 0,
    pagina: 1,
    limite: 10,
    totalPaginas: 0
  });
  const [loading, setLoading] = useState(false);
  const [movimentacaoSelecionada, setMovimentacaoSelecionada] = useState(null);

  useEffect(() => {
    if (!aberto || !processo) {
      setMovimentacoes([]);
      setPaginacao({
        total: 0,
        pagina: 1,
        limite: 10,
        totalPaginas: 0
      });
      setMovimentacaoSelecionada(null);
      return;
    }

    const processoId = processo._id || processo.id;

    if (!processoId) {
      console.error("Processo sem ID para carregar histórico.");
      setMovimentacoes([]);
      return;
    }

    const carregarMovimentacoes = async () => {
      setLoading(true);

      try {
        const resposta =
          await movimentacaoProcessualService.listarPorProcesso(processoId);

        const dados = Array.isArray(resposta?.dados)
          ? resposta.dados
          : [];

        setMovimentacoes(dados);

        setPaginacao(
          resposta?.paginacao || {
            total: dados.length,
            pagina: 1,
            limite: dados.length,
            totalPaginas: dados.length > 0 ? 1 : 0
          }
        );
      } catch (error) {
        console.error(
          "Erro ao carregar histórico de movimentações:",
          error
        );

        setMovimentacoes([]);

        setPaginacao({
          total: 0,
          pagina: 1,
          limite: 10,
          totalPaginas: 0
        });
      } finally {
        setLoading(false);
      }
    };

    carregarMovimentacoes();
  }, [aberto, processo]);

  const abrirMovimentacao = async (id) => {
    if (!id) {
      console.error("ID da movimentação não informado.");
      return;
    }

    try {
      const movimentacao =
        await movimentacaoProcessualService.buscarPorId(id);

      if (!movimentacao) {
        console.error("Movimentação não encontrada.");
        return;
      }

      setMovimentacaoSelecionada({
        ...processo,
        movimentacao
      });
    } catch (error) {
      console.error(
        "Erro ao buscar detalhes da movimentação:",
        error
      );
    }
  };

  const handleFecharModalPrincipal = () => {
    setMovimentacaoSelecionada(null);
    setMovimentacoes([]);
    setPaginacao({
      total: 0,
      pagina: 1,
      limite: 10,
      totalPaginas: 0
    });
    onFechar();
  };

  const formatarData = (data) => {
    if (!data) {
      return "-";
    }

    const dataConvertida = new Date(data);

    if (Number.isNaN(dataConvertida.getTime())) {
      return "-";
    }

    return dataConvertida.toLocaleDateString("pt-BR");
  };

  if (!aberto || !processo) {
    return null;
  }

  return (
    <>
      <div className="modal-overlay">
        <div
          className="modal"
          style={{
            width: "95%",
            maxWidth: "1200px"
          }}
        >
          <h2>HISTÓRICO PROCESSUAL</h2>

          {loading ? (
            <div
              style={{
                padding: "20px",
                textAlign: "center"
              }}
            >
              Carregando movimentações...
            </div>
          ) : (
            <>
              <table className="table">
                <thead>
                  <tr>
                    <th>Data</th>
                    <th>Evento</th>
                    <th>Fase</th>
                    <th>Urgência</th>
                    <th>Órgão</th>
                  </tr>
                </thead>

                <tbody>
                  {movimentacoes.length > 0 ? (
                    movimentacoes.map((item) => {
                      const id = item._id || item.id;

                      const urgencia =
                        item.urgencia || "MEDIA";

                      return (
                        <tr
                          key={id}
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            abrirMovimentacao(id)
                          }
                        >
                          <td>
                            {formatarData(
                              item.dataDisponibilizacao
                            )}
                          </td>

                          <td>
                            {item.evento || "-"}
                          </td>

                          <td>
                            {item.faseProcessual || "OUTRO"}
                          </td>

                          <td>
                            <span
                              className={`badge-urgencia ${urgencia}`}
                            >
                              {urgencia}
                            </span>
                          </td>

                          <td>
                            {item.orgao || "-"}
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td
                        colSpan="5"
                        style={{
                          textAlign: "center",
                          padding: "15px"
                        }}
                      >
                        Nenhuma movimentação registrada para
                        este processo.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              {paginacao.total > 0 && (
                <div
                  style={{
                    marginTop: "15px",
                    textAlign: "right",
                    fontSize: "14px"
                  }}
                >
                  Total de movimentações:{" "}
                  <strong>{paginacao.total}</strong>
                </div>
              )}
            </>
          )}

          <div className="modal-botoes">
            <button
              type="button"
              onClick={handleFecharModalPrincipal}
            >
              Fechar
            </button>
          </div>
        </div>
      </div>

      <ProcessoModal
        aberto={!!movimentacaoSelecionada}
        processo={movimentacaoSelecionada}
        usuarios={usuarios}
        setProcesso={setMovimentacaoSelecionada}
        onSalvar={() => {
          if (onSalvarProcesso && movimentacaoSelecionada) {
            onSalvarProcesso(movimentacaoSelecionada);
          }
        }}
        onFechar={() =>
          setMovimentacaoSelecionada(null)
        }
      />
    </>
  );
};

export default HistoricoProcessual;